import i18n from '../../../i18n'
import { BUILDING_OPTIONS_WITH_AVATAR_PARAMS } from '../../Building'
import {
  TableBuildingCell,
  TableDateCell,
  TableTextCell,
  TableTitleCell,
  TableUserCell,
  TableUserListCell,
} from '../../Table'
import { toUserMultiValue } from '../../User'

import { BuildingGroupTableCellName } from './BuildingGroupTableRow.constants'

import BuildingGroupIcon from '../../../icons/buildings-group.svg'

function getBuildingLabel(option) {
  return option?.title
}

function getBuildingApiParams(id, value) {
  return {
    ...BUILDING_OPTIONS_WITH_AVATAR_PARAMS,
    building_group: id,
    exclude_id: value?.id,
  }
}

export function renderCell({ item, name, scrollRef, ...restProps }) {
  const { [name]: value } = item

  switch (name) {
    case BuildingGroupTableCellName.Title:
      return (
        <TableTitleCell
          {...restProps}
          additionalTooltipInfo={i18n.t(
            'BuildingGroupTable.ClickToOpenBuildingGroupKey'
          )}
          avatarProps={{
            Icon: BuildingGroupIcon,
            src: item.avatar,
            text: value,
          }}
          value={value}
        />
      )
    case BuildingGroupTableCellName.ExternalId:
    case BuildingGroupTableCellName.FlatsCount:
    case BuildingGroupTableCellName.InhabitantCount:
      return <TableTextCell {...restProps} value={value} />
    case BuildingGroupTableCellName.Buildings:
      return (
        <TableBuildingCell
          {...restProps}
          getApiParams={getBuildingApiParams}
          getLabel={getBuildingLabel}
          id={item.id}
          scrollRef={scrollRef}
          value={value}
        />
      )
    case BuildingGroupTableCellName.CreatedAt:
    case BuildingGroupTableCellName.Updated:
      return <TableDateCell {...restProps} value={value} />
    case BuildingGroupTableCellName.CreatedBy:
    case BuildingGroupTableCellName.UpdatedBy:
      return (
        <TableUserCell
          {...restProps}
          value={value ? toUserMultiValue(value) : null}
        />
      )
    case BuildingGroupTableCellName.ResponsibleManager:
      return (
        <TableUserListCell
          {...restProps}
          scrollRef={scrollRef}
          value={value?.map(toUserMultiValue)}
        />
      )
    default:
      return null
  }
}
